import { render, staticRenderFns } from "./ConfiguracaoApuracaoAcordo.vue?vue&type=template&id=787ed353&lang=html&"
import script from "./ConfiguracaoApuracaoAcordo.vue?vue&type=script&lang=js&"
export * from "./ConfiguracaoApuracaoAcordo.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracaoApuracaoAcordo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/configuracao/ConfiguracaoApuracaoAcordo.vue
// module id = 1153
// module chunks = 28